import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function CategoryRow({ item, CounterComponent, isSubCategory, user }) {
    // const [count, setCount] = useState('');
    const [count, setCount] = useState(() => {
        return item;
    });

    const handleCountLoaded = (countValue) => {
        setCount(countValue);
    };

    if (count == null || count == 0) {
        console.log('Count is null or 0, not rendering row');
        return null; // Ne pas rendre si count est null ou 0
    }
    
    
    return (
        <tr>
            <td><strong>{item.categorie}</strong></td>
            <td>
                <h5>
                    <CounterComponent data={item.id} onCountLoaded={handleCountLoaded} />
                </h5>
            </td>
            <td>
                <Link to={`/${isSubCategory ? 'souscategorie' : 'candidats'}/${item.id}`} className="btn btn-sm btn-primary mr-2">
                    Voir tous les CV
                </Link>
                {user.role === 'Administrateur' && (
                    <Link to={`/categorie/${item.categorie_cv_id || item.id}`} className="btn btn-sm btn-info">
                        Détail
                    </Link>
                )}
            </td>
        </tr>
    );
}

export default CategoryRow;
